import util from 'util';
import { CONSTANT } from '@const';
import { ClientContact, ClientType } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class ClientService extends ApiService {
	static getClients(): Promise<ClientType[]> {
		const params: ApiParams = {
			method: 'GET',
			url: CONSTANT.CLIENTS_APP_API_URL,
		};
		return this.executeApiRequest(params);
	}

	static getClient(clientId: string): Promise<ClientType> {
		const params: ApiParams = {
			method: 'GET',
			url: util.format(CONSTANT.LEGAL_ENTITY_API_URL, clientId),
		};
		return this.executeApiRequest(params);
	}

	static async updateClientContact(
		clientId: string,
		client: Partial<ClientContact>,
	): Promise<Partial<ClientContact>> {
		const params: ApiParams = {
			method: 'PUT',
			url: util.format(CONSTANT.CLIENT_CONTACT_APP_API_URL, clientId),
			data: client,
		};
		return await this.executeApiRequest(params);
	}
}
